//#region Imports
import React, { useState, useEffect, useRef } from 'react';
import { StyleSheet, Platform, SafeAreaView, FlatList, View, useWindowDimensions } from 'react-native';
import { useTheme } from '@react-navigation/native';
import { useAccountContext } from '../../../hooks/useAccountContext';
import CustomButton from '../../../components/CustomButton';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import { useTranslation } from 'react-i18next';
import RoleGuard from '../../../components/RoleGuard';
import { TASKS, TASK_OPTIONS } from '../../../constants/Tasks';
import AdminLeaveManagementScreen from '../HRUtilities/AdminLeaveManagementScreen';

const HRAdminPageUtilities = () => {
    //#region Const Definitions and UseRef and UseState
    const { t } = useTranslation();
    const { width, height } = useWindowDimensions();
    const { account } = useAccountContext();
    const { colors } = useTheme();
    const styles = makeStyles(colors);
    const buttonTable = [0, 1, 2, 3];

    const [showLeaveApplicationApproval, setShowLeaveApplicationApproval] = useState(1);
    const showLeaveApplicationApprovalRef = useRef(1);

    //#region SubMenu Listeners
    const setAllPagesToZero = () => {
        setShowLeaveApplicationApproval(0);
    }

    const pressedOnLeaveApplicationApproval = () => {
        setAllPagesToZero();
        setShowLeaveApplicationApproval(1);
    }
    //#endregion

    //#region UseEffect
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            try {
                localStorage.setItem(
                    "showLeaveApplicationApproval",
                    showLeaveApplicationApprovalRef.current
                );
                localStorage.setItem("isRefresh", "true");
                localStorage.setItem("lastVisitedScreen", "HRAdminPageUtilities");
            } catch (error) {
                console.log(error.message);
            }
        };
        if (Platform.OS === "web") {
            window.addEventListener("beforeunload", handleBeforeUnload);
            return () => {
                window.removeEventListener("beforeunload", handleBeforeUnload);
            };
        }
        if (Platform.OS === "web") {
            checkIfRefreshed()
                .then(() => { })
                .catch(console.error);
        }
    }, []);

    //* if refreshed, get data from session storage,
    //* to show same page as before refresh
    const checkIfRefreshed = async () => {
        try {
            let isRefresh = localStorage.getItem("isRefresh");
            if (isRefresh === "true") {
                setShowLeaveApplicationApproval(
                    parseInt(localStorage.getItem("showLeaveApplicationApproval"))
                );
            }
        } catch (error) {
            console.log(error);
        }
    };

    //#region Assign UseRef
    useEffect(() => {
        showLeaveApplicationApprovalRef.current = showLeaveApplicationApproval;
    }, [showLeaveApplicationApproval]);
    //#endregion
    //#endregion


    return (
        <SafeAreaView style={styles.main}>
            {/* Tabs Row */}
            <View>
                <FlatList
                    horizontal
                    showsHorizontalScrollIndicator={true}
                    directionalLockEnabled={true}
                    alwaysBounceVertical={false}
                    data={buttonTable}
                    contentContainerStyle={{
                        alignSelf: "flex-start",
                        marginBottom: "1%",
                    }}
                    showsVerticalScrollIndicator={true} //shows horizontal scroll bar on web
                    renderItem={({ index }) => {
                        return (
                            <SafeAreaView>
                                {index == 0 && (
                                    <RoleGuard parentTask={TASKS.UTILS} task={TASK_OPTIONS.LAA} table='hr' requireCRUD>
                                        <CustomButton
                                            onPress={() => {
                                                pressedOnLeaveApplicationApproval();
                                            }}
                                            text={t("navigate:LAAadmin")}
                                            iconName="people-circle-outline"
                                            show={showLeaveApplicationApproval ? "HOME_SELECTED" : "HOME"}
                                            type={showLeaveApplicationApproval ? "HOME_SELECTED" : "HOME"}
                                            textTop="0"
                                            isGradient={showLeaveApplicationApproval ? true : false}
                                            sz={Platform.OS !== "web" ? 20 : 25}
                                        />
                                    </RoleGuard>
                                )}
                            </SafeAreaView>
                        );
                    }}
                    keyExtractor={(item) => `${item}`}
                />
            </View>

            {/* Views to show depending on Flatlist Selection */}
            {showLeaveApplicationApproval ? (
                <SafeAreaView style={[styles.main]}>
                    <SafeAreaView style={[styles.subMain]}>
                        <AdminLeaveManagementScreen />
                    </SafeAreaView>
                </SafeAreaView>
            ) : (
                <></>
            )}
        </SafeAreaView>
    );
}

const makeStyles = (colors) => StyleSheet.create({
    main: {
        flex: 1,
    },
    mainSubTabs: {
        zIndex: 2000,
        flexDirection: "row",
        alignSelf: 'flex-start',
        marginBottom: '1%',
    },
    subMain: {
        flex: 1,
        marginVertical: 10,
        marginHorizontal: 30,
    },
    row: {
        flexDirection: "row",
    },
    backButton: {
        alignSelf: 'flex-start',
        margin: 10,
        marginBottom: 0
    },
});

export default HRAdminPageUtilities; 